export default {
  title: 'Artículos',
  order_note: 'Nota del pedido',
};
